import Swiper from 'swiper';

export default function setPersonalizados() {
  const sections = document.querySelectorAll('[data-personalizados-icons]');

  sections.forEach((section) => {
    const carousel = section.querySelector('.swiper');

    if (!carousel || carousel.swiper) return;

    new Swiper(carousel, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  });
}
